export default __webpack_public_path__ + "static/media/pin.e07e794c.svg";